"use strict";
/**
 * @author by Gor.Hakobyan on 30-Apr-18.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var PathHelper = /** @class */ (function () {
    function PathHelper() {
    }
    /**
     * key for getting ME Service URL with Application Properties Service
     */
    PathHelper.meServiceUriKey = "me-de-service-url";
    /**
     * key for getting ME Service URL with Application Properties Service
     */
    PathHelper.meReportingServiceUriKey = "me-reporting-service-url";
    /**
     * disaggregation request path
     */
    PathHelper.DISAGGREGATION = '/disaggregates/';
    /**
     * question request path
     */
    PathHelper.QUESTION = '/questionnaires/';
    /**
     * framework request path
     */
    PathHelper.FRAMEWORK = '/frameworks/';
    /**
     * workflow request path
     */
    PathHelper.TRACKING_WORKFLOW = '/workflow/';
    /**
     * framework request path
     */
    PathHelper.IMPLEMENTATION_FRAMEWORKS = '/implementation-frameworks/';
    /**
     * framework request path
     */
    PathHelper.IMPLEMENTATION_FRAMEWORK = '/implementation-framework/';
    /**
     * indicator request path
     */
    PathHelper.INDICATORS = '/indicators';
    /**
     * indicator-template request path
     */
    PathHelper.INDICATOR_TEMPLATES = '/indicator-templates/';
    /**
     * indicator data points request path
     */
    PathHelper.INDICATOR_DATA_POINTS = '/indicators/datapoints/';
    /**
     * indicator request path
     */
    PathHelper.INDICATOR_FUNCTIONS = '/indicators/functions/';
    /**
     * indicator master request path
     */
    PathHelper.INDICATOR_MASTER = '/indicator-master/';
    /**
     * indicator request path
     */
    PathHelper.INDICATOR = '/indicator/';
    /**
     * data points request path
     */
    PathHelper.DATAPOINT = '/datapoints';
    /**
     * framework-indicators request path
     */
    PathHelper.FRAMEWORK_INDICATORS = '/framework-indicators/';
    /**
     * result-areas request path
     */
    PathHelper.RESULT_AREA = '/result-areas/';
    PathHelper.RESULT_AREA_CHECK = '/result-areas/check/';
    PathHelper.IF = '/implementation-framework/';
    PathHelper.ENTITY_INDICATOR = '/entities/Indicator';
    PathHelper.ENTITY = '/entities/';
    PathHelper.VALIDATE = '/indicators/validate';
    /**
     * period request path
     */
    PathHelper.PERIODS = '/periods';
    /**
     * Configs' path
     */
    PathHelper.CONFIG = '/config';
    /**
     * item request path
     */
    PathHelper.ITEM = '/item/';
    PathHelper.MASTER = '/master';
    PathHelper.IPPT = '/ippt/';
    return PathHelper;
}());
exports.PathHelper = PathHelper;
//# sourceMappingURL=path.helper.js.map